import NewApiService from "@/utils/new.api.service";

export default {
    list() {
        return new Promise((resolve, reject) => {
            NewApiService.get("warehouse")
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    create(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.post("warehouse",model)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    
    update(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.put("warehouse/"+model.id,model)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    
    delete(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.delete("warehouse/"+model.id)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    }
    
}